import { render, staticRenderFns } from "./RirekishoReasonNewCard.vue?vue&type=template&id=1d2fa797&scoped=true"
import script from "./RirekishoReasonNewCard.vue?vue&type=script&setup=true&lang=ts"
export * from "./RirekishoReasonNewCard.vue?vue&type=script&setup=true&lang=ts"
import style0 from "./RirekishoReasonNewCard.vue?vue&type=style&index=0&id=1d2fa797&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1d2fa797",
  null
  
)

export default component.exports